import { Outlet } from 'react-router-dom';
import { DeploymentWatcher } from '@/lib/app-version';

/**
 * Every route, signed in or not, sits under the deployment watcher, so an
 * installed app left on sign-in still moves to a new deployment
 * (plan/portal-final/INTERFACES.md section 8).
 */
export function RootLayout() {
  return (
    <>
      <DeploymentWatcher />
      <Outlet />
    </>
  );
}
